<template>
  <div class="special-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :inline="true">
        <FormItem>
          <Button @click="showDraw()"
                  type="success"
                  class="f-r">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showDrawStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="search">
        <FormItem label="标题"
                  label-position="top"
                  prop="name">
          <Input v-model="search.name"></Input>
        </FormItem>
		<FormItem label="唯一标识"
                  label-position="top"
                  prop="database_ziduan_name">
          <Input v-model="search.database_ziduan_name"></Input>
        </FormItem>
        <FormItem>
          <Select v-model="search.type"
                  :style="{'width':'180px'}">
            <Option v-for="item in cateSelect"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
		<FormItem v-if="search.type == 3">
			<Input v-model="search.xuanxiang_content" placeholder="请输入关键词,以逗号隔开"></Input>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showDrawStatus = false">取消</Button>
        <Button type="primary"
                @click="createHot('specialValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>
  
  <script>
export default {
  name: "special-list",
  data () {
    return {
      title: "添加",
      loading: true,
      dataloading: true,//0文本1图片2富文本3选项4附件
      cateSelect: [
        { id: 0, name: "文本" },
        { id: 1, name: "图片" },
        { id: 2, name: "富文本" },
        { id: 3, name: "选项" },
        { id: 4, name: "附件" },
      ],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      columns: [
        {
          title: "Id",
          key: "id",
          width: 100
        },
        {
          title: "名称",
          key: "name",
          width: 100
        },
        {
          title: "类型",
          key: "type",
          width: 100
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      search: {
		name: null,
		type: null,
		xuanxiang_content: null
	  },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      showDrawStatus: false,
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
  },
  methods: {
    getTableList: function () {
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.listtype.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showDraw () {
      this.search = {
        name: "",
      };
      this.tablelist1 = [];
      this.showDrawStatus = !this.showDrawStatus;
    },
    // 详情
    detail (id) {
      this.title = "修改";
      this.showDrawStatus = !this.showDrawStatus;
      this.$api.listtype.detail({ id: id }).then(res => {
        this.search = res.result;
		this.search.id = id;

      });
    },
    // 添加
    createHot (name) {
      if (this.search.id == null || this.search.id == 0) {
        this.$api.listtype.create(this.search).then(res => {
          if (res.code == 200) {
            this.showDrawStatus = !this.showDrawStatus;
			this.search.id = null;
            this.search.name = "";
			this.search.type = null;
			this.search.xuanxiang_content = null;
            this.getTableList();
          }
        });
      } else {
        this.$api.listtype.edit(this.search).then(res => {
          if (res.code == 200) {
            this.showDrawStatus = !this.showDrawStatus;
			this.search.id = null;
            this.search.name = "";
			this.search.type = null;
			this.search.xuanxiang_content = null;
            this.getTableList();
          }
        });
      }
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.listtype.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },

    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
	  this.getTableList();
    },


  }
};
  </script>
  <style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
  